module.exports = __webpack_public_path__ + "static/markham-6a588aaeb0dddad86f6380aa2b1ccbd7.png";